import * as tslib_1 from "tslib";
import isIE from "../../../utils/isIE";

if (isIE()) {
  require('core-js/es6/map');

  require('core-js/es6/set');
}

import * as React from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'perfect-scrollbar';
import cx from 'classnames';
import each from 'lodash/each';
import { eventClassNameMapper } from './consts';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import "./Scrollbar.css";

var Scrollbar =
/** @class */
function (_super) {
  tslib_1.__extends(Scrollbar, _super);

  function Scrollbar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.scrollbarRef = React.createRef();
    _this.eventClassHandlers = new Map(); // methods can be invoked from the ref to this component

    _this.getScrollTop = function () {
      if (_this.scrollbarRef.current) {
        return _this.scrollbarRef.current.scrollTop;
      }
    };

    _this.getScrollLeft = function () {
      if (_this.scrollbarRef.current) {
        return _this.scrollbarRef.current.scrollLeft;
      }
    };

    _this.getClientHeight = function () {
      if (_this.scrollbarRef.current) {
        return _this.scrollbarRef.current.clientHeight;
      }
    };

    _this.getScrollHeight = function () {
      if (_this.scrollbarRef.current) {
        return _this.scrollbarRef.current.scrollHeight;
      }
    };

    _this.getOffset = function () {
      if (_this.scrollbarRef.current) {
        var _a = _this.scrollbarRef.current,
            clientHeight = _a.clientHeight,
            scrollHeight = _a.scrollHeight,
            scrollTop = _a.scrollTop;
        return scrollHeight - clientHeight - scrollTop;
      }
    };

    _this.setScrollTop = function (top) {
      if (_this.scrollbarRef.current) {
        _this.scrollbarRef.current.scrollTop = top;

        _this.ps.update();

        return true;
      }

      return false;
    };

    _this.setScrollLeft = function (left) {
      if (_this.scrollbarRef.current) {
        _this.scrollbarRef.current.scrollLeft = left;

        _this.ps.update();

        return true;
      }

      return false;
    };

    return _this;
  }

  Scrollbar.prototype.componentDidMount = function () {
    var _this = this;

    this.ps = new PerfectScrollbar(this.scrollbarRef.current, this.props.options);
    each(eventClassNameMapper, function (eventName, eventClass) {
      var eventHandler = _this.props[eventName];

      if (eventHandler) {
        var handler = function handler() {
          return eventHandler(_this.scrollbarRef.current);
        };

        _this.eventClassHandlers.set(eventClass, handler);

        if (_this.scrollbarRef.current) {
          _this.scrollbarRef.current.addEventListener(eventClass, handler, false);
        }
      }
    });
  };

  Scrollbar.prototype.componentDidUpdate = function () {
    this.ps.update();
  };

  Scrollbar.prototype.componentWillUnmount = function () {
    var e_1, _a;

    try {
      // unhook up evens
      for (var _b = tslib_1.__values(this.eventClassHandlers), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = tslib_1.__read(_c.value, 2),
            eventClass = _d[0],
            handler = _d[1];

        if (this.scrollbarRef.current) {
          this.scrollbarRef.current.removeEventListener(eventClass, handler, false);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    this.eventClassHandlers.clear();
    this.ps.destroy();
  };

  Scrollbar.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        className = _a.className,
        style = _a.style,
        alwaysVisible = _a.alwaysVisible;
    var forwardProps = {
      ref: this.scrollbarRef,
      className: cx(className, 'nx-scrollbar', {
        'nx-scrollbar--always-visible': alwaysVisible
      })
    };

    if (typeof children === 'function') {
      return children(forwardProps);
    }

    return React.createElement("div", tslib_1.__assign({}, forwardProps, {
      style: style
    }), children);
  };

  Scrollbar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    className: PropTypes.string,
    options: PropTypes.object,
    style: PropTypes.object,
    alwaysVisible: PropTypes.bool,
    onScrollY: PropTypes.func,
    onScrollX: PropTypes.func,
    onScrollUp: PropTypes.func,
    onScrollDown: PropTypes.func,
    onScrollLeft: PropTypes.func,
    onScrollRight: PropTypes.func,
    onYReachStart: PropTypes.func,
    onYReachEnd: PropTypes.func,
    onXReachStart: PropTypes.func,
    onXReachEnd: PropTypes.func
  };
  Scrollbar.defaultProps = {
    style: {},
    alwaysVisible: false
  };
  return Scrollbar;
}(React.Component);

export default Scrollbar;

try {
  // @ts-ignore
  Scrollbar.__docgenInfo = {
    "description": "",
    "displayName": "Scrollbar",
    "props": {
      "options": {
        "defaultValue": null,
        "description": "",
        "name": "options",
        "required": false,
        "type": {
          "name": "Options | undefined"
        }
      },
      "style": {
        "defaultValue": {
          value: "{}"
        },
        "description": "",
        "name": "style",
        "required": true,
        "type": {
          "name": "CSSProperties"
        }
      },
      "alwaysVisible": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "alwaysVisible",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "onScrollY": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollY",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onScrollX": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollX",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onScrollUp": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollUp",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onScrollDown": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollDown",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onScrollLeft": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollLeft",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onScrollRight": {
        "defaultValue": null,
        "description": "",
        "name": "onScrollRight",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onYReachStart": {
        "defaultValue": null,
        "description": "",
        "name": "onYReachStart",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onYReachEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onYReachEnd",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onXReachStart": {
        "defaultValue": null,
        "description": "",
        "name": "onXReachStart",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      },
      "onXReachEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onXReachEnd",
        "required": false,
        "type": {
          "name": "((el: HTMLElement) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}